import { render, staticRenderFns } from "./company-info-basic-display.vue?vue&type=template&id=0a2e5061&scoped=true&"
import script from "./company-info-basic-display.vue?vue&type=script&lang=js&"
export * from "./company-info-basic-display.vue?vue&type=script&lang=js&"
import style0 from "./company-info-basic-display.vue?vue&type=style&index=0&id=0a2e5061&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e5061",
  null
  
)

export default component.exports